import { render, staticRenderFns } from "./MultiSelectUsers.vue?vue&type=template&id=3ae5836c"
import script from "./MultiSelectUsers.vue?vue&type=script&lang=ts"
export * from "./MultiSelectUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports